import React from "react";
import "./styles/SaaSDtPlatform.scss";
import { useTranslation } from "react-i18next";
const SaaSDtPlatform = () => {
  const { t } = useTranslation();
  const des = t("digitalTwin.saasDt.contents.platform.des", { returnObjects: true }) as { text: string; highlight: string }[];
  const service = t("digitalTwin.saasDt.contents.platform.service", { returnObjects: true }) as {
    logoPaht: string;
    logoText: string;
    labelColor: string;
    serviceCategory: string;
    serviceName: string;
    serviceDes: string[];
    serviceResult: string[];
  }[];

  const example = [
    "/imgs/platform_client_example_01.png",
    "/imgs/platform_client_example_02.png",
    "/imgs/platform_client_example_03.png",
    "/imgs/platform_client_example_04.png",
    "/imgs/platform_client_example_05.png",
    "/imgs/platform_client_example_06.png",
    "/imgs/platform_client_example_07.png",
    "/imgs/platform_client_example_08.png",
    "/imgs/platform_client_example_09.png",
  ];
  return (
    <>
      <div className="saas_dt_platform_wrap">
        <div className="contents">
          <section id="platform_warp">
            <div className="platform_name_wrap">
              <div className="logo_box">
                <img src="/imgs/logo_netzero_1.png" alt="" />
              </div>
              <span>{t("digitalTwin.saasDt.contents.platform.name")}</span>
            </div>
            <div className="platform_des_wrap">
              <div className="des">
                {des.map((data, index) => {
                  return (
                    <span className={data.highlight} key={`${data.text}_${index}_123`}>
                      {data.text}
                    </span>
                  );
                })}
              </div>
            </div>
            <div className="platform_service_wrap">
              {service.map((data, index) => {
                return (
                  <div className="card" key={`${data.serviceCategory}_${index}`}>
                    <div className="top_label" style={{ backgroundColor: data.labelColor }}>
                      <div className="title_wrap">
                        <div className="img_box">
                          <img src={data.logoPaht} alt={data.serviceCategory} />
                        </div>
                        <span>{data.logoText}</span>
                      </div>
                      <div className="category_wrap">{data.serviceCategory}</div>
                    </div>
                    <div className="service" style={{ border: `1px solid ${data.labelColor}` }}>
                      <div className="service_name_wrap" style={{ color: data.labelColor, borderBottom: `1px solid ${data.labelColor}` }}>
                        {data.serviceName}
                      </div>
                      <div className="service_des_wrap">
                        {data.serviceDes.map((text, index2) => {
                          return <div key={`${text}_${index2}`}>{text}</div>;
                        })}
                      </div>
                      <div className="img_box">
                        <img src="/imgs/icon_arrow_down.png" alt="arrow" />
                      </div>
                      <div className="service_result_wrap">
                        {data.serviceResult.map((text, index) => {
                          return <div key={`${text}_${index}`}>{text}</div>;
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="platform_middleware_wrap">
              <div className="repository_wrap box">
                {t("digitalTwin.saasDt.contents.platform.middleware.repository")}
                <div className="img_box">
                  <img src="/imgs/icon_building_1.png" alt="buliding" />
                </div>
              </div>
              <div className="api_wrap box"> {t("digitalTwin.saasDt.contents.platform.middleware.api")}</div>
              <div className="arrow_wrap">
                <div className="img_box">
                  <img src="/imgs/icon_arrow_down.png" alt="arrow" />
                </div>
                <div className="img_box">
                  <img src="/imgs/icon_arrow_down.png" alt="arrow" />
                </div>
              </div>
            </div>
            <div className="platform_client_wrap">
              {t("digitalTwin.saasDt.contents.platform.client")}
              <div className="img_box">
                <img src="/imgs/icon_building_2.png" alt="buliding" />
              </div>
            </div>
          </section>
          <section id="service_example_wrap">
            {example.map((path, index) => {
              return <img key={`${path}_${index}`} src={path} alt="platform-service" />;
            })}
          </section>
        </div>
      </div>
    </>
  );
};

export default SaaSDtPlatform;
